import PropTypes from 'prop-types';
import {
  Stack,
  Flex,
  Text,
} from '@mantine/core';
import classes from './style.module.css';

const CustomizedMixTotalBox = (props) => {
  const { icon, label, value } = props;

  return (
    <div className={classes.container}>
      <Stack gap={4}>
        <Flex mb={16} w='100%' align='flex-end' gap='xs'>{icon}
          <Text size='sm' c='#8D9096' fw={400}> {label} </Text>
        </Flex>
        <Text size='lg' fw={'bold'} c='#1A1E29'> {value} </Text>
      </Stack>
    </div>
  );
};

CustomizedMixTotalBox.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomizedMixTotalBox;
